export default {
  name: 'with-root',
  functional: true,
  props: ['show'],
  render: function(createElement, context) {
    // Remove unnecessary text nodes
    const children = context.children.filter(vnode => vnode.tag)

    if (children.length !== 1) {
      console.warn('this component accepts only one root node in its slot')
    }

    if (context.props.show) {
      return children[0]
    }
    else {
      return children[0].children
    }
  }
}
